import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';

import api, { APIError } from '../api';
import auth from '../auth';
import config from '../config';

import {Wrap} from '../components/common';
import {BtnBorder} from '../components/buttons';
import {Helmet} from 'react-helmet';
import LoadingPage from '../components/loading_page';
import {useCheckShutdown} from '../shutdown';
const {siteName} = config;


export default function Home() {
  const history = useHistory();
  const [subjects, setSubjects] = useState();
  const [student, setStudent] = useState();
  const [attend_histories, setAttendHistories] = useState();
  const [panic, setPanic] = useState(null);
  const checkShutdown = useCheckShutdown();

  useEffect(() => {
    checkShutdown()
      .then(() => {
        Promise.all([
          api.get('/subjects'),
          api.get('/students/history'),
          auth.student()
        ])
          .then(([res1, res2, res3]) => {
            setSubjects(res1.data);
            setAttendHistories(res2.data);
            setStudent(res3.data);
          })
          .catch(e => setPanic(e));
      });
  }, []);

  if (panic) throw panic;

  const loaded = attend_histories && student && subjects;

  return loaded ? <HomeMain attend_histories={attend_histories} student={student} subjects={subjects}/> : <LoadingPage />;
}

export const HomeMain = ({attend_histories, student, subjects}) => {
  const history = useHistory();
  const [viewing, setVewing] = useState([]);

  const togglePhoto = (i) => {
    let v = viewing.slice();
    if ( v.includes(i) ) {
       v = v.filter((val, ii) => val !== i);
    } else {
      v.push(i);
    }
    setVewing(v);
  }

  const item = (val, i) => {
    const attend_history = attend_histories.filter((v, _) => v.subject_number == val.subject_number).shift();

    const viewStatus = (attend_history) => {
      if ( attend_history.status == 1 ) {
        return <>未受講</>;
      } else {
        return <>{attend_history.status_text}</>;
      }
    };

    const result = () => {
      const expanded = viewing.includes(i);

      const photo = (
        <div css={css`flex: 1`}>
          <div css={css`display: flex; align-items: center; cursor: pointer; color: #999; &:hover { color: #666; }`} onClick={() => togglePhoto(i)}>
            <span className="material-icons-outlined" css={css`margin-right: 6px;`}>face</span>
            <span css={css`user-select: none`}>{expanded ? '撮影写真' : '撮影写真を表示'}</span>
          </div>
          <div css={css`
            display: ${expanded ? `flex` : `none`};
            justify-content: space-between;
            padding: 10px 0 0;
            @media screen and (max-width: 720px) {
              display: ${expanded ? 'block' : 'none'};
            }

            span {
              display: ${expanded ? `block` : `none`};
              width: calc(100% / 3 - 15px);
              img {
                width: 100%;
              }
              @media screen and (max-width: 720px) {
                width: 100%;
                margin-bottom: 4px;
              }
            }
          `}>
            {attend_history.photos.map((val, i) => (
              <span key={i}><img src={config.api_url + val}/></span>
            ))}
          </div>
        </div>
      );

      const time = (
        <div css={css`
          font-size: 12px;
          color: #999;
          margin-left: 1rem;

          @media (max-width: 720px) {
            margin-left: 0;
            margin-top: 1rem;
          }
        `}>
          <span css={css`margin-right: 0.5rem`}>視聴完了日時</span>{moment(attend_history.ended_at).format('YYYY年M月D日H時m分')}
        </div>
      );

      return (
        <div css={css`
          border-top: 1px solid #EEE;
          margin-top: 20px;
          padding: 10px 0 0;
          display: flex;

          @media (max-width: 720px) {
            flex-direction: column;
          }
        `}>
          {photo}
          {time}
        </div>
      );
    }

    return (
      <li key={i} css={css`
        background-color: white;
        padding: 20px;
        margin-top: 1rem;
        border: 1px solid #EEE;
      `}>
      <div css={css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        @media screen and (max-width: 720px) {
          display: block;
        }
      `}>
        <div css={css`display: flex; align-items: flex-start;`}>
          <p css={css`color: #999999; margin: 0 10px 0 0; flex: none`}>学科{val.subject_number}</p>
          <p css={css`margin: 0`}>{val.title}</p>
        </div>
        <div css={css`
          display: flex;
          align-items: center;

          .btn {
            width: 125px;
          }

          @media screen and (max-width: 720px) {
            margin-top: 10px;
            justify-content: space-between;

            .btn {
              margin-top: 1rem;
            }
          }
        `}>
          <p css={css`
            margin: 0 20px 0 0;
            display: flex;
            align-items: center;
            color: #666;
            font-size: 14px;
          `}>
          <i css={css`
            width: 8px;
            height: 8px;
            display: block;
            background-color: ${(() => {
              if (!attend_history) return 'transparent';

              switch(+attend_history.status) {
                case 1:
                  return `transparent`;
                case 2:
                  return `#DE0000`;
                case 3:
                  return `#DEDE00`;
                default:
                  return `#00B500`;
              }
            })()};
            border-radius: 50%;
            margin-right: 10px;

            @media (max-width: 720px) {
              display: ${!attend_history || attend_history.status == 1 ? 'none' : 'block'};
            }
          `}></i>
            {attend_history ? viewStatus(attend_history) : '未受講'}
          </p>
          <BtnBorder name={attend_history && attend_history.status == 4 ? `再受講` : `受講する`} action={() => history.push('/attend/' + val.subject_number)}/>
        </div>
        </div>
        {attend_history && attend_history.photos.length > 0 && result()}
      </li>
    );
  };

  const studentInfo = (
    <div css={css`margin-bottom: 2.5rem`}>{student.name} <span css={css`color: #666`}>(教習生番号: {student.student_number})</span></div>
  );

  return (
    <Wrap>
      <Helmet>
        <title>{siteName}</title>
      </Helmet>
      <div>
        {studentInfo}
        <p css={css`font-size: 24px; color: #AAA; margin-bottom: 1rem`}>1段階学科</p>
        {subjects.length > 0 && <ul>
          {subjects.map((val, i) =>
            val.stage == 1 && item(val, i)
          )}
        </ul>}
      </div>
      <div css={css`margin-top: 2.5rem`}>
        <p css={css`font-size: 24px; color: #AAA; margin-bottom: 1rem`}>2段階学科（12・22・23学科から先にご受講下さい）</p>
        {student && student.stage_second == 1 ?
        <>
          {subjects.length > 0 && <ul>
            {subjects.map((val, i) =>
              val.stage == 2 && item(val, i)
            )}
          </ul>}
        </>
        :
        <p css={css`font-size: 24px; color: #CCCCCC; text-align: center; margin-top: 20px;`}>2段階目の学科の受講条件を満たしていません。​</p>
        }
      </div>
    </Wrap>
  );
};
